import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const productAlsoSlider = document.querySelector('.product-also__slider');
if (productAlsoSlider !== null) {
    new Swiper(productAlsoSlider, {
        modules: [Navigation],
        slidesPerView: 6,
        navigation: {
            nextEl: '.product-also__navigation--next',
            prevEl: '.product-also__navigation--prev'
        },
        spaceBetween: 20,
        breakpoints: {
            0: {
              slidesPerView: 1,
              spaceBetween: 10
            },
            576: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            768: {
              slidesPerView: 3,
            },
            991: {
                slidesPerView: 4,
            },
            1200: {
                slidesPerView: 5,
            },
            1400: {
                slidesPerView: 6,
            }
        }
    })
}


const productSlider = document.querySelector('.product__slider');
if (productSlider !== null) {
    new Swiper(productSlider, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        navigation: {
            nextEl: '.product__slider .detail-slider__navigation--next',
            prevEl: '.product__slider .detail-slider__navigation--prev'
        },
        spaceBetween: 20,
        pagination: {
            el: '.detail-slider__pagination',
            bulletClass: 'detail-slider__pagination-bullet',
            bulletActiveClass: 'detail-slider__pagination-bullet--active',
            clickable: true
        }
    })

    if (productSlider.querySelectorAll('.product__slider-item').length <= 1) {
        console.log('hide arrows');
        productSlider.querySelectorAll('.detail-slider__pagination, .detail-slider__navigation').forEach(element => {
            element.classList.add('product__slider--hide')
        })
    }
}